import { axios, Response } from '..'
import { GetTaskTagsResponse } from './get-all-task-tags'

/* Not used in anywhere */

export const getTaskTagsByIds = (
  taskTagsIds: number[] | undefined,
  taskId: string
): Response<GetTaskTagsResponse[]> => {
  return axios.get(`/v1/tasks/${taskId}/tags/${taskTagsIds}`)
}
